export enum AlarmLevel {
  HIGH = 'HIGH',
  MID = 'MID',
  LOW = 'LOW',
}
